import { useStore } from 'effector-react'
import { $error, $offer, getOffer, offerMounted } from './model'
import { useEffect } from 'react'

export const useOffer = () => {
  const offer = useStore($offer)
  const error = useStore($error)

  const loading = useStore(getOffer.pending)

  useEffect(() => {
    offerMounted()
  }, [])

  return { offer, loading, error }
}
